import { p as palette } from '../base/color-DMp1DFwP.js';

/* eslint-disable id-length */
const secondaryView = {
  bg: palette.white,
  header: {
    bg: palette.gray[50],
    border: {
      color: palette.gray[200]
    }
  },
  closeButton: {
    color: palette.squidInk
  },
  closeIcon: {
    color: palette.gray[700]
  }
};

export { secondaryView as s };
//# sourceMappingURL=secondaryView-Dmb5CGIK.js.map
